import { IAddress } from "@app-payments/data-access/entities/payments.interface";
import { ERegistrationType } from "./profile.enum";

export interface IChangePaswordRequest {
    Email: string;
    OldPassword: string;
    NewPassword: string;
}

export interface IUser {
    AvatarObjetoId: string;
    AvatarUrl: string;
    Birthdate: string;
    DataCadastro: string;
    Email: string;
    FirstName: string;
    Id: string;
    LastName: string;
    LoginCount: number;
    Master: boolean;
    Module: string;
    Modulo: string;
    Sexo: string;
    TenantId: string;
    TermsAccepted: boolean
    TipoCadastro: string;
    TipoCadastroAbstraido: string;
    Url: string;
    UserName: string;
    UserTenantId: string;
    ReceivesPix?: boolean; //not legacy only
    PagueLaId?: string; //not legacy only
}

export enum AppVersion {
  Old = 0,
  New = 1
}

export type TOwnerSettings = {
  CertificateArchive: any | null;
  AppVersion?: AppVersion;
  Culture: string;
  IsValid: boolean;
  Logos: any | null;
  Operation: any | null;
  OwnerSettingsId: string;
  PrintLogoStorageId: string;
  RectangularLogoStorageId: string;
  SquareLogoStorageId: string;
  Timezone: string;
  UpdatedOn: string;
  Currency: string;
  MaxCapacity?: number;
}

export interface IUserPayload {
    PessoaId: string;
    PrimeiroNome: string;
    Sobrenome: string;
    DataNascimento: string;
    Sexo: string;
}
export interface TelefoneViewModel {
    PessoaId?: string;
    TelefoneId?: string;
    TenantId?: string;
    Tipo: string;
    Numero: string;
    CodigoPais?: string;
    NumeroConfirmado?: boolean;
    Observacao?: string;
    CelularMaster?: boolean;
    FromResponse?: boolean;
}

export interface IUserResponse {
    PessoaId?: string;
    TenantId?: string;
    FuncaoId?: string;
    Funcao?: string;
    TenantIdAbstraido?: string;
    PessoaCd?: number;
    AcessoCd?: number;
    TipoCadastro?: string;
    IdAtendimento?: string;
    PrimeiroNome: string;
    Sobrenome: string;
    Nome?: string;
    DataNascimento?: string;
    Idade?: number;
    QtAvaliacoes?: number;
    QtFichas?: number;
    DataProximaAvaliacao?: string;
    Novo?: boolean;
    Sexo?: string;
    Cpf?: string;
    Email?: string;
    Marcadores?: string;
    EnderecoComercial?: string;
    CidadeComercial?: string;
    EstadoComercial?: string;
    CepComercial?: string;
    DataCadastro?: string;
    RazaoSocial?: string;
    Fantasia?: string;
    InscricaoEstadual?: string;
    Cnpj?: string;
    TipoPessoa?: string;
    Situacao?: string;
    Segmento?: string;
    TelefoneCelular?: TelefoneViewModel;
    PessoaCrmId?: string;
    Modulo?: string;
    Origem?: string;
    DataExpiracaoLicenca?: string;
    VrAbertoAtual?: number;
    ConsultorId?: string;
    PagueLaPessoaId?: string;
    AvatarStorageObjectId?: string;
    DataFimContrato?: string;
    DataConversao?: string;
    DataUltimoLogin?: string;
    Rg?: string;
    DiaPreferidoVencimento?: number;
    PessoaDependenteId?: string;
    ResponsavelPrimeiroNome?: string;
    ResponsavelSobrenome?: string;
    NomeCompleto?: string;
    MensagemAcesso?: string;
    DataBloqueioAcesso?: string;
    EmailFornecedor?: string;
    TelefoneFornecedor?: string;
    DataEntregaPrevista?: string;
    NumeroNotaFiscal?: string;
    NumerosTelefones?: string;
    Master: boolean;
    FornecedorId?: string;
    TipoBanco?: string;
    Grupo?: string;
    InscricaoMunicipal?: string;
    Gympass?: string;
    DataUltimaAlteracaoNome?: string;
    DataLiberacaoAcessoAte?: string;
    EmiteBoleto?: boolean;
    PrincipalGrupoId?: string;
    UnidadeGrupoId?: string;
    PossuiAppTreino?: boolean;
    Telefones?: TelefoneViewModel[];
    Enderecos?: IAddress[];
    PossuiFacial?: boolean;
    PossuiImpressaoDigital?: boolean;
    ImpressaoDigital?: string;
    QuantidadeFacial?: number;
    TipoTributacao?: number;
    TipoTributacaoEspecial?: number;
    OptanteSimplesNacional?: boolean;
    DataUltimaAtivacao?: string;
    UsuarioAtivacaoId?: string;
    NomeUsuarioAtivacao?: string;
    DataUltimaInativacao?: string;
    UsuarioInativacaoId?: string;
    NomeUsuarioInativacao?: string;
    PossuiServicoPixAtivo?: boolean;
    FromResponse?: boolean;
}


export type IPersonDataAsync = {
PersonId: string;
  FirstName: string;
  LastName: string;
  Email: string;
  TenantId: string;
  IsActive: boolean;
  IsOwner: boolean;
  FriendlyCode: string;
  ReceivesPix: boolean;
  GympassId: string;
  PagueLaId: string;
  RegistrationType: ERegistrationType;
  CallCode: string;
  DisplayName: string;
}